import { SignalCategory } from '../types/context.types';

export interface SignalCategoryMeta {
  label: string;
  subtitle: string;
  placeholder: string;
  tip: string;
  color: string;
}

export const SIGNAL_CATEGORY_META: Record<SignalCategory, SignalCategoryMeta> = {
  goal: {
    label: 'Goal',
    subtitle: 'Business Outcomes',
    color: '#28a745',
    placeholder: "e.g., 'Increase signup conversion by 20%'",
    tip: 'Goals describe success at a business level - use measurable outcomes when possible.',
  },
  audience: {
    label: 'Audience',
    subtitle: 'Who You Serve',
    color: '#007bff',
    placeholder: "e.g., 'Enterprise SaaS users'",
    tip: 'Describe who will use what you’re designing - roles, contexts, or segments.',
  },
  tone: {
    label: 'Tone',
    subtitle: 'Voice & Style',
    color: '#6f42c1',
    placeholder: "e.g., 'Professional but approachable'",
    tip: 'Tone shapes voice, copy, and visual feel - pick a few words that capture the vibe.',
  },
  constraint: {
    label: 'Constraint',
    subtitle: 'Limits & Boundaries',
    color: '#fd7e14',
    placeholder: "e.g., 'Must work without JavaScript'",
    tip: 'Constraints are limits the AI must respect - technical, brand, accessibility, or scope.',
  },
  insight: {
    label: 'Insight',
    subtitle: 'Research Findings',
    color: '#20c997',
    placeholder: "e.g., 'Users abandon at the pricing step'",
    tip: 'Insights come from research, analytics, or feedback that should inform decisions.',
  },
  persona: {
    label: 'Persona',
    subtitle: 'User Archetypes',
    color: '#e83e8c',
    placeholder: "e.g., 'Marketing Manager Maya, 34, time-poor'",
    tip: 'Personas are concrete user archetypes - give them names, traits, and motivations.',
  },
  requirement: {
    label: 'Requirement',
    subtitle: 'Must-Haves',
    color: '#ffc107',
    placeholder: "e.g., 'Must support SSO login'",
    tip: 'Requirements are non-negotiable features or capabilities the design must include.',
  },
  metric: {
    label: 'Metric',
    subtitle: 'Success Measures',
    color: '#6c757d',
    placeholder: "e.g., 'Daily active users'",
    tip: 'Metrics are how success is measured. Pair them with goals when possible.',
  },
};

export const SIGNAL_CATEGORY_ORDER: SignalCategory[] = [
  'goal',
  'audience',
  'tone',
  'constraint',
  'insight',
  'persona',
  'requirement',
  'metric',
];
